export const SkillSets = [
//   {
//       "title": "CSS",
//       "icon": "css",
//       "color": "onec-orange",
//       "text": "Over 3 Years experience",
//       "status": "EXPERT"
//   },
  {
      "title": "Java Script",
      "icon": "js",
      "color": "onec-green",
      "text": "Over 3 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "PHP",
      "icon": "php",
      "color": "onec-blue",
      "text": "Over 3 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "C Sharp",
      "icon": "csharp",
      "color": "onec-green",
      "text": "Over 4 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "C / C++",
      "icon": "cplus",
      "color": "onec-blue",
      "text": "Over 3 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "JAVA",
      "icon": "java",
      "color": "onec-green",
      "text": "Over 2 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "Python",
      "icon": "python",
      "color": "onec-orange",
      "text": "Less then 1 Years experience",
      "status": "BEGINNER"
  },
  {
      "title": "SASS",
      "icon": "sass",
      "color": "onec-blue",
      "text": "Over 1 Years experience",
      "status": "EXPERT"
  },
//   {
//       "title": "Pascal",
//       "icon": "delphi",
//       "color": "onec-orange",
//       "text": "Over 3 Years experience",
//       "status": "EXPERT"
//   },
  {
      "title": "Type Script",
      "icon": "ts",
      "color": "onec-green",
      "text": "Less then 1 Years experience",
      "status": "EXPERT"
  },
  {
    "title": "Go-lang",
    "icon": "go",
    "color": "onec-semiorange",
    "text": "Over 2 Years experience",
    "status": "EXPERT"
  },
  {
      "title": "SQL",
      "icon": "database",
      "color": "onec-blue",
      "text": "Over 3 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "Android XML",
      "icon": "xml",
      "color": "onec-green",
      "text": "Over 2 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "ASP",
      "icon": "asp",
      "color": "onec-orange",
      "text": "OVER 1 Years experience",
      "status": "INTERMEDIET"
  }
]